<template>
  <div>
    <div style="display: flex">
      <div class="col" style="text-align: left">
        <ButtonMedium
          v-can="'teaching.add_epmevaluationbibliographicresource'"
          v-if="allows_crud && can_update"
          :tooltip_text="
            $t('reusable.common.addTooltip', {
              entity: $t(
                'matterProgram.matterProgramView.bibliographicResource'
              ),
            })
          "
          :click_button="
            () =>
              $bvModal.show(`new-epm_evaluation_bibliographic_resource-modal`)
          "
          :text_button="$t('reusable.common.add')"
          :icon="'plus'"
          :variant="'primary'"
        >
        </ButtonMedium>
      </div>
    </div>
    <GenericBTable
      :items="epm_evaluation_bibliographic_resource"
      :pagination="epm_evaluation_bibliographic_resource.length"
      :fields="EPMEvaluationBibliographicResourceFields"
      :filter="input_search"
      :filterCustom="filterCustom"
      @emitChangeSearchField="changeInputSearch"
      :show_pagination="true"
      :search_filter="true"
      :columns_display="false"
      :allows_crud="allows_crud"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
    >
      <template #cell(bibliographic_resource)="row">
        <RenderVHtml
          :content="
            getBibliographicResourceDescription(row.item.bibliographic_resource)
          "
        ></RenderVHtml>
      </template>
      <template v-if="allows_crud" #cell(actions)="row">
        <ButtonSmall
          v-if="can_update && allows_crud"
          :tooltip_text="
            $t('reusable.common.editTooltip', {
              entity: $t(
                'matterProgram.matterProgramView.bibliographicResource'
              ),
            })
          "
          :click_button="
            () =>
              $bvModal.show(
                `edit-epm_evaluation_bibliographic_resource-modal-${row.item.id}`
              )
          "
          :class="``"
          :icon="'square'"
        ></ButtonSmall>
        <ButtonSmall
          v-if="can_delete && allows_crud"
          :click_button="() => askForDeleteEPMEvaBiblioResource(row.item.id)"
          :tooltip_text="
            $t('reusable.common.deleteTooltip', {
              entity: $t(
                'matterProgram.matterProgramView.bibliographicResource'
              ),
            })
          "
          :icon="'trash'"
        ></ButtonSmall>
        <b-modal
          :id="`edit-epm_evaluation_bibliographic_resource-modal-${row.item.id}`"
          :title="
            $t('reusable.common.editModalTitle', {
              entity: $t(
                'matterProgram.matterProgramView.bibliographicResource'
              ),
            })
          "
          size="md"
          hide-footer
        >
          <EPMEvaluationBibliographicResourceForm
            :EPMEvaBibliResource="row.item"
            :epm_evaluation_id="epm_evaluation_id"
            :bibliographic_resources="bibliographic_resources"
            :bibliographic_resource_types="bibliographic_resource_types"
            @updated="slotUpdatedEPMEvaBiblioResource"
          ></EPMEvaluationBibliographicResourceForm>
        </b-modal>
      </template>
    </GenericBTable>
    <b-modal
      :id="`new-epm_evaluation_bibliographic_resource-modal`"
      :hide-footer="true"
      :title="$t('matterProgram.matterProgramView.createBibliographicResource')"
      size="lg"
    >
      <EPMEvaluationBibliographicResourceForm
        :epm_evaluation_id="epm_evaluation_id"
        :bibliographic_resources="bibliographic_resources"
        :bibliographic_resource_types="bibliographic_resource_types"
        @created="slotCreatedEPMEvaBiblioResource"
      ></EPMEvaluationBibliographicResourceForm>
    </b-modal>
  </div>
</template>

<script>
import { toast } from "@/utils/utils";
import { mapGetters } from "vuex";
export default {
  name: "EPMEvaluationBibliographicResource",
  components: {
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    GenericBTable: () => import("@/components/reusable/GenericBTable"),
    EPMEvaluationBibliographicResourceForm: () =>
      import("./EPMEvaluationBibliographicResourceForm"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
  },
  props: {
    epm_evaluation_id: {
      type: Number,
      required: true,
    },
    ep_matter: {
      type: Object,
      required: true,
    },
    allows_crud: {
      type: Boolean,
      required: true,
    },
    can_delete: {
      type: Boolean,
      required: false,
    },
    can_update: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      epm_evaluation_bibliographic_resource: [],
      bibliographic_resources: [],
      bibliographic_resource_types: [],
      sortBy: "is_mandatory",
      sortDesc: false,
      input_search: "",
    };
  },
  computed: {
    ...mapGetters({
      institution: "getInstitution",
    }),
    EPMEvaluationBibliographicResourceFields() {
      const is_duoc_institution =
        this.institution && this.institution.internal_use_id == "duoc.cl";

      return [
        {
          key: "bibliographic_resource",
          label: this.$t(
            "matterProgram.matterProgramView.bibliographicResources"
          ),
          sortable: true,
          // La celda muestra la descripción del recurso, no su id
          sortByFormatted: (value, key, item) =>
            this.getBibliographicResourceDescription(item.bibliographic_resource),
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "details",
          label: this.$t("matterProgram.matterProgramView.details"),
          sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "is_mandatory",
          label: this.$t("matterProgram.matterProgramView.type"),
          sortable: true,
          tdClass: "text-center",
          formatter: (value) => {
            return value
              ? this.$t("matterProgram.matterProgramView.mandatoryBibliography")
              : this.$t(
                  "matterProgram.matterProgramView.complementaryBibliography"
                );
          },
          display_column: is_duoc_institution,
        },
        {
          key: "actions",
          label: "",
          display_column: true,
          thClass: "noprint",
          tdClass: "noprint",
        },
      ];
    },
  },
  methods: {
    changeInputSearch(input_search) {
      this.input_search = input_search;
    },
    getType(type) {
      return type
        ? this.$t("matterProgram.matterProgramView.mandatoryBibliography")
        : this.$t("matterProgram.matterProgramView.complementaryBibliography");
    },
    filterCustom(row) {
      if (
        this.$filtered(
          this.getBibliographicResourceDescription(row.bibliographic_resource),
          this.input_search
        ) ||
        this.$filtered(row.details, this.input_search) ||
        this.$filtered(this.getType(row.is_mandatory), this.input_search)
      ) {
        return true;
      } else {
        return false;
      }
    },
    slotCreatedEPMEvaBiblioResource(response) {
      this.epm_evaluation_bibliographic_resource.push(response);
      this.$bvModal.hide("new-epm_evaluation_bibliographic_resource-modal");
    },
    slotUpdatedEPMEvaBiblioResource(response) {
      const index = this.epm_evaluation_bibliographic_resource.findIndex(
        (x) => x.id == response.id
      );
      if (index != -1) {
        this.epm_evaluation_bibliographic_resource[
          index
        ].bibliographic_resource = response.bibliographic_resource;
        this.epm_evaluation_bibliographic_resource[index].details =
          response.details;
        this.epm_evaluation_bibliographic_resource[index].is_mandatory =
          response.is_mandatory;

        this.$bvModal.hide(
          `edit-epm_evaluation_bibliographic_resource-modal-${response.id}`
        );
      }
    },
    askForDeleteEPMEvaBiblioResource(epm_eva_biblio_resource_id) {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$t(
            "matterProgram.matterProgramView.bibliographicResource"
          ),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$restful
            .Delete(
              `/teaching/epm-evaluation-bibliographic-resource/${epm_eva_biblio_resource_id}/`
            )
            .then(() => {
              const index =
                this.epm_evaluation_bibliographic_resource.findIndex(
                  (x) => x.id == epm_eva_biblio_resource_id
                );
              if (index != -1) {
                this.epm_evaluation_bibliographic_resource.splice(index, 1);
                toast(
                  this.$t(
                    "matterProgram.matterProgramView.bibliographicResourceDeleted"
                  )
                );
              }
            });
        }
      });
    },
    getBibliographicResourceDescription(id) {
      if (!id) return "";
      const bibliographic_resource = this.bibliographic_resources.find(
        (x) => x.id == id
      );
      if (bibliographic_resource) return bibliographic_resource.description;
      return "";
    },
    fetchEPMEvaluationBibliographicResource() {
      if (!isNaN(this.epm_evaluation_id))
        this.$restful
          .GetAll(
            `/teaching/epm-evaluation-bibliographic-resource/?egress_profile_matter_evaluation=${this.epm_evaluation_id}`
          )
          .then((response) => {
            this.epm_evaluation_bibliographic_resource = response;
          });
    },
    fetchBibliographicResource() {
      if (this.ep_matter)
        this.$restful
          .GetAll(
            `/teaching/bibliographic-resource/?matter=${this.ep_matter.matter}`
          )
          .then((response) => {
            this.bibliographic_resources = response;
          });
    },
    fetchBibliographicResourceType() {
      this.$restful
        .GetAll(`/teaching/bibliographic-resource-type/`)
        .then((response) => {
          this.bibliographic_resource_types = response;
        });
    },
  },
  created() {
    this.fetchEPMEvaluationBibliographicResource();
    this.fetchBibliographicResource();
    this.fetchBibliographicResourceType();
  },
};
</script>

<style scoped src="@/utils/rich_text_editor.css">
</style>
<style scoped>
</style>